export type MaterialId = 'recyclage' | 'ordures' | 'organiques' | 'verts'

export interface Material {
  id: MaterialId
  label: string
  hint: string
}

export interface Collection {
  id: string
  weekday: string
  date: string
  materials: MaterialId[]
}

/**
 * Baie-Trinité collecte deux bacs roulants au chemin ; le reste passe par le centre
 * de tri ou l'écocentre. Les deux dernières entrées ne sont donc pas des collectes
 * au chemin : elles restent listées pour les rappels.
 */
export const materials: Record<MaterialId, Material> = {
  ordures: { id: 'ordures', label: 'Ordures', hint: 'Bac roulant' },
  recyclage: { id: 'recyclage', label: 'Recyclage', hint: 'Bac roulant' },
  organiques: { id: 'organiques', label: 'Encombrants', hint: 'Centre de tri' },
  verts: { id: 'verts', label: 'Résidus domestiques dangereux', hint: 'Écocentre ou détaillant' },
}

export const citizenAddress = '112, route 138, Baie-Trinité'

export const quickPrompts = [
  'Bac non ramassé',
  'Horaire du centre de tri',
  'Quel bac sortir ?',
  'Autre problème',
]

/**
 * Le calendrier 2026 n'est publié qu'en PDF : le jour de collecte ci-dessous est
 * plausible mais reste à confirmer auprès de la Municipalité.
 */
export const collections: Collection[] = [
  {
    id: 'sept-18',
    weekday: 'Aujourd’hui',
    date: 'vendredi 18 septembre',
    materials: ['ordures', 'recyclage'],
  },
  {
    id: 'sept-25',
    weekday: 'Vendredi',
    date: '25 septembre',
    materials: ['ordures'],
  },
  {
    id: 'oct-02',
    weekday: 'Vendredi',
    date: '2 octobre',
    materials: ['ordures', 'recyclage'],
  },
]

/** Suivi en direct du camion pour la collecte du jour. */
export const liveCollection = {
  material: 'ordures' as MaterialId,
  sector: 'Village',
  truck: 'Camion 1',
  startedAt: 'Départ du garage à 7 h',
  home: [49.4186, -67.2986] as [number, number],
  /** Trajet du camion le long de la route 138, jusqu’à votre adresse. */
  route: [
    [49.4155, -67.3125],
    [49.4162, -67.3086],
    [49.4168, -67.3052],
    [49.4173, -67.3028],
    [49.4178, -67.3009],
    [49.4181, -67.2999],
    [49.4184, -67.2992],
    [49.4186, -67.2986],
  ] as [number, number][],
  /** Avancement initial du camion sur le trajet (0 → 1). */
  startProgress: 0.42,
}
